import React, { useEffect, useState } from "react";
import { Input, Button, Switch, Modal } from "antd";
import { useNavigate, useParams, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import firebase from "../../config/firebase";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import "../../styles2/GroupForm.css";

import "firebase/auth";
import "firebase/firestore";

function GroupForm() {
  const db = firebase.firestore();
  const navigate = useNavigate();
  const { id } = useParams();

  const userLogado = useSelector((state) => state.usuarioLogado);

  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");
  const [ativo, setAtivo] = useState(true);
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);


  useEffect(() => {
    const unsubscribe = db
      .collection("tb_group")
      .onSnapshot((snapshot) => {
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setGroups(data);
      });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (id) {
      loadGroup();
    }
  }, [id]);

  if (userLogado <= 0) {
    return <Navigate to="/login" />;
  }

  // 🔹 CARREGAR GRUPO (EDIÇÃO)
  const loadGroup = async () => {
    try {
      const doc = await db.collection("tb_group").doc(id).get();
      if (doc.exists) {
        const data = doc.data();
        setNome(data.name || "");
        setDescricao(data.description || "");
        setAtivo(data.active ?? true);
      }
    } catch (error) {
      console.error("Erro ao carregar grupo:", error);
    }
  };

  // 🔹 VALIDAÇÃO
  const getInvalidFields = () => {
    const erros = [];

    if (!nome || !nome.trim()) {
      erros.push("Nome");
    }

    // Verificar duplicata de nome (ignorar o próprio registro se estiver editando)
    const nomeTrimmed = nome.trim().toLowerCase();
    const nomeDuplicado = groups.some(
      (group) =>
        group.name?.toLowerCase() === nomeTrimmed &&
        group.id !== id
    );

    if (nomeDuplicado) {
      erros.push("Nome (já existe um grupo com este nome)");
    }

    return erros;
  };

  // 🔹 SALVAR / ATUALIZAR
  const handleSave = async () => {
    const camposInvalidos = getInvalidFields();

    if (camposInvalidos.length > 0) {
      Modal.error({
        title: "Campo obrigatório ",
        content: (
          <div>
            <p>O seguinte campo obrigatório estão vazio:</p>
            <ul
              style={{
                marginTop: 20,          
                paddingLeft: 0,
                listStyle: "none",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",   
                
              }}
            >
              {camposInvalidos.map((campo, index) => (
                <li key={index} style={{ marginBottom: 4, color: "red" }}>
                  {campo}
                </li>
              ))}
            </ul>
          </div>
        ),
      });
      return;
    }

    setLoading(true);

    const payload = {
      name: nome.trim(),
      description: descricao,
      active: ativo,
    };

    try {
      if (id) {
        await db
          .collection("tb_group")
          .doc(id)
          .update({ ...payload, updated_at: new Date() });
      } else {
        await db.collection("tb_group").add({
          ...payload,
          created_at: new Date(),
        });
      }

      Modal.success({
        title: id ? "Grupo atualizado" : "Grupo cadastrado",
        content: id
          ? "O grupo foi atualizado com sucesso."
          : "O grupo foi cadastrado com sucesso.",
        onOk: () => {
          navigate("/group");
        },
      });
    } catch (error) {
      console.error("Erro ao salvar grupo:", error);
      Modal.error({
        title: "Erro ao salvar",
        content: "Ocorreu um erro ao salvar o grupo. Tente novamente.",
      });
    } finally {
      setLoading(false);
    }
  };


  return (
    <NewMiniDrawer
      divOpen={
        <div className="freight-content">
          <div className="container">
            <h4>{id ? "Editar Grupo" : "Cadastro de Grupos"}</h4>

            <div className="row mt-4">
              <div className="col-md-6">
                Nome <span style={{ color: "red" }}>*</span>
                <Input
                  value={nome}
                  onChange={(e) => {
                   const value = e.target.value;
                    setNome(value);
                  }}
                />
              </div>

              <div className="col-md-6">
                <label>Ativo</label>
                <br />
                <Switch
                  checked={ativo}
                  onChange={setAtivo}
                  style={{
                    backgroundColor: ativo ? "#012443" : "#d9d9d9", 
                  }}
                />

              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-12">
                <label>Descrição</label>
                <Input.TextArea
                  rows={3}
                  value={descricao}
                  onChange={(e) => setDescricao(e.target.value)}
                />
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-12 d-flex gap-2">
                <div className="row mt-4">
                  <div className="col-md-12 d-flex gap-2">
                    <Button
                      className="btn-form-fortio"
                      onClick={() => navigate("/group")}
                    >
                      Cancelar
                    </Button>

                    <Button
                      className="btn-form-fortio"
                      loading={loading}
                      onClick={handleSave}
                    >
                      Salvar
                    </Button>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      }
    />
  );
}

export default GroupForm;
